var _path, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_234_1943",
    style: {
      "maskType": "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 12,
    height: 12
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6667 4H11.3333V3.33333C11.3333 2.59695 10.7364 2 10 2H3.33333C2.59695 2 2 2.59695 2 3.33333V10.6667C2 11.403 2.59695 12 3.33333 12H4.66667V12.6667C4.66667 13.403 5.26362 14 6 14H12.6667C13.403 14 14 13.403 14 12.6667V5.33333C14 4.59695 13.403 4 12.6667 4ZM3.33333 10.6667V3.33333H10V4H6C5.26362 4 4.66667 4.59695 4.66667 5.33333V10.6667H3.33333ZM6 12.6667H12.6667V5.33333H6V12.6667Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_234_1943)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "black"
  }))));
};

export default __webpack_public_path__ + "static/media/icon-catalog-slabs.903e69ec.svg";
export { SvgComponent as ReactComponent };